import device from '../../../styles/device'
import styled from 'styled-components'

export const MainHeading = styled.h1`
  text-align: center;
  font-size: 30px;
  margin: -20px 30px 40px 30px;
  @media ${device.tabletPortrait} {
    font-size: 50px;
    margin-bottom: 50px;
  }
`

export const SubHeading = styled('p')`
  max-width: ${(props) => props.theme.siteWidth};
  padding: 0 60px 100px;
  margin: auto;
  text-align: center;
  color: ${(props) => props.theme.colors.darkGrey};
`

export const Wrapper = styled('div')`
  background-color: rgb(53, 152, 170);
  > div {
    max-width: 900px;
    margin: -120px auto 0;
    padding-bottom: 50px;

    @media ${device.tabletPortrait} {
      margin-top: -50px;
      transform: translateY(-120px);
      padding-bottom: 0px;
    }
  }
  h2 {
    font-size: 2.2rem;
  }
  position: relative;
  margin: 150px auto;
  @media ${device.mobLandscape} {
    margin: 150px auto;
  }
  @media ${device.tabletPortrait} {
    margin: 200px auto;
  }

  > svg {
    position: absolute;
    z-index: -1;
    top: -50px;
    left: -13%;
    width: 126%;
    @media ${device.tabletPortrait} {
      top: -80px;
      left: 0;
      width: 100%;
    }
  }
`
